import { Checkbox, Form } from "antd";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  label?: string;
  placeholder: string;
  errorMessage?: string;
  control: Control<TSchema>;
  isVertical?: boolean;
  // Shrinks the label's font-size, for long labels in tight columns (ex: "Analyse de cause nÃ©cessaire")
  smallLabel?: boolean;
}

export default function FieldCheckbox<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const { name, label, errorMessage, control, isVertical, smallLabel } = props;
  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      label={
        label ? (
          <span
            className={smallLabel ? "text-small-size" : undefined}
            style={{ whiteSpace: "nowrap" }}
          >
            {label}
          </span>
        ) : undefined
      }
      layout={isVertical ? "vertical" : "horizontal"}
      labelCol={isVertical ? { span: 24 } : undefined}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox checked={field.value} onChange={field.onChange} />
        )}
      />
    </Form.Item>
  );
}
